import React, { useState, useEffect } from "react";

const withTimedDisplay = (Component, timeout = 5000) => {
  return React.memo(function TimedComponent(props) {
    const [isVisible, setIsVisible] = useState(true);
    useEffect(() => {
      const timer = setTimeout(() => {
        props.setShowAlert(false);
        setIsVisible(false);
      }, timeout);

      return () => clearTimeout(timer);
    }, [timeout]);

    return isVisible ? <Component {...props} /> : null;
  });
};

export default withTimedDisplay;
